import { defineComponent, computed } from "vue";
import QrcodeVue from "qrcode.vue";
import { useProjectTheme } from "store";

interface ImageSettings {
  src?: string;
  x?: number;
  y?: number;
  height?: number;
  width?: number;
  excavate?: boolean;
}


// 继承 QrcodeVueProps，并可以覆盖或添加自定义 props
export default defineComponent({
  name: "ThemedQrcode",
  props: {
    value: { type: String, default: '' },
    margin: { type: Number, default: 1 },
    size: { type: Number, default: 100 },
    level: { type: String as PropType<'L' | 'M' | 'Q' | 'H'>, default: 'H' },
    imageSettings: { type: Object as PropType<ImageSettings>, default: () => undefined }
  },
  setup(props, { attrs }) {
    const themeStore = useProjectTheme();

    const getColors = computed(() => {
      const colorsMap = {
        light: { background: "#ffffff", foreground: "#000000" },
        dark: { background: "#ffffff", foreground: "#000000" },
      };
      return colorsMap[themeStore.themeType] ?? colorsMap.light;
    });

    return () => {
      const { background, foreground } = getColors.value;
      const qrcodeProps: any = {
        ...props,
        ...attrs,
        background,
        foreground,
      };
      if (!props.imageSettings) {
        delete qrcodeProps.imageSettings
      }

      return <QrcodeVue {...qrcodeProps} />;
    };
  },
});
